import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import NewsList from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import WorksList from "@/pages/works/page";
import WorkDetail from "@/pages/works/detail/page";
import ActorsList from "@/pages/actors/page";
import ActorDetail from "@/pages/actors/detail/page";
import About from "@/pages/about/page";
import Contact from "@/pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "news", element: <NewsList /> },
      { path: "news/:id", element: <NewsDetail /> },
      { path: "works", element: <WorksList /> },
      { path: "works/:id", element: <WorkDetail /> },
      { path: "actors", element: <ActorsList /> },
      { path: "actors/:id", element: <ActorDetail /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <Contact /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;